<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div style="height:32px">
			<vButton @click="cancel" class="pull-right margin-left-10">取消</vButton>
			<vButton @click="click" theme="primary" class="pull-right">确定</vButton>
		</div>
	</div>
</template>
<script>
import TableList from "@components/templates/tablelist"
import { 
    HttpPlatformSystem, 
    HttpNewPlatformSystem
} from "@/service/managechannel/managechannel";
export default {
	props:['sysdeliveries','syscarrier','sysservice'],
	components: {
		TableList
	},
	methods: {
		checkChange(rows, val) {
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
		getData() {
			return {
				// ajaxRequest: HttpPlatformSystem,
                ajaxRequest: HttpNewPlatformSystem,
				startUp: true,
                initFormData: {
					"search[EQ_active]":1
				},
				Searchs: {
					show: true,
					style: "border:none;",
					// labelWidth: 'auto',
					align: "left"

				},
				SearchsData: [
                    // {
                    //     label: "ShippingMethod Code",
                    //     tag: 'vSelect',
                    //     key: 'EQ_carrierServiceCode',
                    //     show: true,
                    //     options:this.sysdeliveries.map(function(item){
                    //         return {
                    //             value:item.carrierServiceCode,
                    //             label:item.carrierServiceCode
                    //         }
                    //     }),
                    //     props:{
                    //         filterable:true,
                    //         clearable:true
                    //     },
                    // }, 
                    {
                        label: "Carrier",
                        tag: 'vSelect',
                        key: 'EQ_carrierCode',
                        show: true,
                        // options:this.syscarrier.map(function(item){
                        //     // console.log(item)
                        //     return {
                        //         value:item,
                        //         label:item
                        //     }
                        // }),
                        options:this.syscarrier.map(item => {
                            return {
                                label: item.carrierCode,
                                value: item.carrierCode
                            };
                        }),
                        props:{
                            filterable:true,
                            clearable:true
                        },
                    },
                    {
                        label: "Service",
                        tag: 'vSelect',
                        key: 'EQ_carrierServiceCode',
                        show: true,
                        options:this.sysservice.map(function(item){
                            // console.log(item)
                            return {
                                value:item,
                                label:item
                            }
                        }),
                        props:{
                            filterable:true,
                            clearable:true
                        },
                    }
                ],
				columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: "center",
                        formName: 'id',
                        isRadio:true,
                    }, 
                    // {
                    //     title: "ShippingMethod Code",
                    //     key: 'carrierServiceCode'
                    // }, 
                    {
                        title: "Carrier",
                        key: 'carrierCode'
                    }, 
                    {
                        title: "Service",
                        // key: 'carrierServiceName',
                        key: "carrierServiceCode"
                    }
                ]
			}
		}
	},
}
</script>